import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledEmpDetailInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  top: 66px;
  z-index: 1;
`;

export const StyledEmpDetailCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;
`;

export const StyledEmpDetailIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 14%) 0px 2px 2px 1px;
  padding: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
  &:hover {
    box-shadow: rgb(136 8 8 / 74%) 0px 2px 2px 1px;
  }
`;
export const StyledEmpDetailBoxImage = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 10px;
`;

export const StyledEmpDetailName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 20px;
`;

export const StyledEmpDetailNameTag = styled.div`
  width: 120px;
  height: 120px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 10px 0 10px 10px;
  padding: 9px;

  background-color: ${DIGIPOSTHEME.colors.primaryAkbankWhite};

  font-size: 20px;
  color: ${DIGIPOSTHEME.colors.red};
  font-weight: 700;
  font-family: Campton;

  border: 2px solid ${DIGIPOSTHEME.colors.footerGrey};
  border-radius: 50%;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 0;
    padding: 6px;
  }
`;

export const StyledEmpDetailBox = styled.div`
  width: 200px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #f5f4f6;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 25%) 1px 1px 1px;
  margin: 10px 15px 0 0;
`;

export const StyledEmpTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledEmpOuterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledEmpLabel = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 16px;
  font-weight: 600;

  pointer-events: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 13px;
  }
`;

export const StyledEmpDescription = styled.div`
  display: flex;
  align-items: center;

  margin-right: 8px;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 13px;
  font-weight: 300;

  pointer-events: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 10px;
  }
`;

export const StyledEmpValueContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledEmpDetailWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  top: 66px;
  z-index: 1;
`;
export const StyledEmpDetailText = styled.p`
  font-family: "Campton";
  font-size: "18px";
  text-align: "18px";
  font-weight: "300";
  text-transform: "none";
  cursor: pointer;
  letter-spacing: "0.1px";
  color: ${DIGIPOSTHEME.colors.black};
  pointer-events: none;
`;
